<template>
  <div class="home">
    <login :withenterprise="true">
      <v-icon slot="eye-icon" name="eye"></v-icon>
      <v-icon slot="eye-icon-closed" name="eye-off"></v-icon>
    </login>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  methods: {},
};
</script>
